import { render, staticRenderFns } from "./ExamsPage.vue?vue&type=template&id=179d9c12&scoped=true&lang=pug"
import script from "./ExamsPage.vue?vue&type=script&lang=js"
export * from "./ExamsPage.vue?vue&type=script&lang=js"
import style0 from "./ExamsPage.vue?vue&type=style&index=0&id=179d9c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d9c12",
  null
  
)

export default component.exports